import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);

    // Only send message if service worker is available and active
    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: "CURRENT_ROUTE",
        route: location.pathname,
        timestamp: Date.now()
      });
    }
  }, [location.pathname]); // Re-run when the path changes

  return null; // This component doesn't render anything
};

export default RouteChangeTracker; 